<template>
    <div
        v-if="status === 'loading' || status === true"
        class="spinner-border spinner-border-sm"
        role="status"
    >
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: [String, Boolean],
            required: false
        }
    }
}
</script>
